export const buttonnavbar = {
  color: "#fff",
  backgroundColor: "#484a75",
  borderRadius: "25px",
  px: 2.5,
  py: 0.6,
  fontFamily: "Archivo, Arial, sans-serif",
  textTransform: "uppercase",
  fontSize: "0.75rem",
  fontWeight: 500,
  letterSpacing: "0.6px",
  transition: "all 0.25s ease",

  "&:hover": {
    backgroundColor: "#e3effb",
    color: "#484a75",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
};


export const ButtonNavInferior = (scrolled) => ({

position: "relative",

fontFamily: "Archivo, Arial, sans-serif",

fontSize: "0.82rem",

fontWeight: 600,

textTransform: "uppercase",

letterSpacing: "0.8px",

borderRadius:0,

px:2,

py:1,

transition:"all .3s ease",


color: scrolled 
? "#ffffff"
: "#585857",


"&::after": {

content:'""',

position:"absolute",

left:"50%",

bottom:6,

width:0,

height:"2px",

backgroundColor: scrolled
? "#c69ba5"
: "#484a75",

transition:"all .35s ease",

transform:"translateX(-50%)",

},



"&:hover":{

backgroundColor:"transparent",

color:scrolled
?"#c69ba5"
:"#484a75"

},


"&:hover::after":{

width:"70%"

},



"&.active":{

color:scrolled
?"#c69ba5"
:"#484a75"

},



"&.active::after":{

width:"70%"

},


});

export const StyleNavResponsive= {
    py: 1.5,
          px: 3,
          transition: "all .3s ease",
          borderLeft: "4px solid transparent",

          "& .MuiListItemText-primary": {
            fontFamily: "Archivo, Arial, sans-serif",
  textTransform: "uppercase",
            fontWeight: 600,
            fontSize: "0.8rem",
           
            letterSpacing: "0.8px",
            color: "484a75",
            transition: "all .3s ease",
          },

          "&:hover": {
            backgroundColor: "#484a7598",
            borderLeftColor: "#e3effb",
          },

          "&:hover .MuiListItemText-primary": {
            color: "#e3effb",
          },

          "&.active": {
            backgroundColor: "rgba(37,99,235,.10)",
            borderLeftColor: "#e3effb",
          },

          "&.active .MuiListItemText-primary": {
            color: "#484a75",
            fontWeight: 700,
          },
}
export const StyleNavIn = {
display:{
xs:"none",
md:"flex"
},
justifyContent:"flex-end",
alignItems:"center",
}